import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './auth/authConfig';
import { appInsights } from './appInsights';

export const pca = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
   <React.StrictMode>
    <MsalProvider instance={pca}>
      <App />
    </MsalProvider>
   </React.StrictMode>
);

reportWebVitals();
